import {FC, useEffect} from 'react'
import Link from 'next/link'
import cn from 'classnames'
import useActualCart from '@framework/actual-cart/use-cart'
import useCustomer from '@framework/customer/use-customer'
import s from './UserNav.module.css'
import {getCustomerToken} from '@framework/utils'
import ProfileUserNav from '@components/common/profileUserNav'

interface Props {
  className?: string
  colorLight?: any
}

const countItem = (count: number, item: { quantity: number, [key: string]: any }) => count + item.quantity

const UserNav: FC<Props> = ({className, colorLight}) => {
  const {data: actualCart} = useActualCart()
  const {data: customer, mutate} = useCustomer()
  const itemsCount = (actualCart?.lines as any[])?.reduce(countItem, 0) ?? 0
  const customerToken = getCustomerToken()
  useEffect(() => {
    if (!customer && customerToken) {
      mutate()
    }
  }, [customer, mutate, customerToken])

  return (
    <nav className={cn(s.root, className, 'userNav')}>
      <ul className={s.list}>
        {customer && (
          <li className={cn('mr-space4', 'userItem')}>
            <ProfileUserNav></ProfileUserNav>
            {/*<span className={s.user_nav_link_text}>Login</span>*/}
          </li>
        )}
        {!customer && (
          <li className={cn(s.item, s.fillItem, s.login, 'fillItem')}>
            <Link href="/auth/login">
              <span className={'remi-icon icon-32-User-32 text-icon32 text-primary100'}></span>
              {/*<span className={s.user_nav_link_text}>Login</span>*/}
            </Link>
          </li>
        )}
        <li className={cn(s.item, s.strokeItem, 'strokeItem')}>
          <Link href="/cart" className={'block h-e32'} aria-label="Cart">
              <span className={'remi-icon icon-32-Handbag-32 text-icon32 text-primary100'}></span>
              {/*<span className={s.user_nav_link_text}>Warenkorb</span>*/}
              {itemsCount > 0 &&
                <span style={colorLight ? { backgroundColor: colorLight } : undefined} className={s.bagCount + ' ' + (className === 'checkout' ? s.checkout : '')}>{itemsCount}</span>}
          </Link>
        </li>
      </ul>
    </nav>
  )
}

export default UserNav
